import React, {useState} from 'react';
import CustomButton from "./CustomButton";

const days: ReadonlyArray<string> = ['friday', 'saturday', 'sunday'];

interface PostcardData {
    src: string;
    alt: string;
    zIndex: number;
    isAnimating: boolean;
    rotation: number;
    rotationClass: string;
}


const Schedule: React.FC = () => {
    const [activeTab, setActiveTab] = useState<string>('friday');
    const [postCards, setPostCards] = useState<PostcardData[]>(
        [
            {src: "/images/Postcard1.png", alt: "Postcard1", rotation: 3, zIndex: 3, isAnimating: false, rotationClass: 'rotate-3'},
            {src: "/images/Postcard2.png", alt: "Postcard2", rotation: -5, zIndex: 2, isAnimating: false, rotationClass: '-rotate-5'},
            {src: "/images/Postcard3.png", alt: "Postcard3", rotation: 10, zIndex: 1, isAnimating: false, rotationClass: 'rotate-10'},
        ]
    )

    const handleAnimate = (day: string) => {
        const activeTabIndex = days.indexOf(activeTab);
        const newTabIndex = days.indexOf(day);

        if (activeTabIndex === newTabIndex) return;

        setPostCards(prev => {
            const updated = [...prev];
            if (newTabIndex === activeTabIndex + 1 || newTabIndex === activeTabIndex - 2) {
                updated[activeTabIndex].isAnimating = true;
            } else {
                updated[newTabIndex].isAnimating = true;
            }
            return updated;
        });

        setTimeout(() => {
            setPostCards(prev => {
                const updated = [...prev];
                if (activeTabIndex === 0 && newTabIndex === 1) {
                    updated[0].zIndex = 1;
                    updated[1].zIndex = 3;
                    updated[2].zIndex = 2;
                }
                if (activeTabIndex === 0 && newTabIndex === 2) {
                    updated[0].zIndex = 2;
                    updated[1].zIndex = 1;
                    updated[2].zIndex = 3;
                }
                if (activeTabIndex === 1 && newTabIndex === 0) {
                    updated[0].zIndex = 3;
                    updated[1].zIndex = 2;
                    updated[2].zIndex = 1;
                }
                if (activeTabIndex === 1 && newTabIndex === 2) {
                    updated[0].zIndex = 2;
                    updated[1].zIndex = 1;
                    updated[2].zIndex = 3;
                }
                if (activeTabIndex === 2 && newTabIndex === 0) {
                    updated[0].zIndex = 3;
                    updated[1].zIndex = 2;
                    updated[2].zIndex = 1;
                }
                if (activeTabIndex === 2 && newTabIndex === 1) {
                    updated[0].zIndex = 1;
                    updated[1].zIndex = 3;
                    updated[2].zIndex = 2;
                }
                return updated;
            })
        }, 500);

        setActiveTab(day);
    };

    const handleAnimationEnd = (finishedCardIndex: number) => {
        setPostCards(prev =>
            prev.map((card, index) => {
                if (index === finishedCardIndex) {
                    return {
                        ...card,
                        isAnimating: false,
                    };
                }
                return card;
            })
        );
    };

    return (
        <section className="md:mb-32 mt-20 mb-56">
            <div className="container mx-auto px-4">
                <div className="max-w-4xl mx-auto relative md:h-[550px]">
                    <div className="flex flex-col items-center justify-center">
                        <div className="flex justify-center mb-12 z-10">
                            {days.map((day) => (
                                <CustomButton
                                    key={day}
                                    onClick={() => handleAnimate(day)}
                                    text={(day === 'friday') ? "Viernes" : (day === 'saturday') ? "Sábado" : (day === 'sunday') ? "Domingo" : ""}
                                    bgColor={activeTab === day
                                                    ? 'bg-[#5a7ca0]'
                                                    : 'text-(--secondary-color) bg-[rgb(var(--calendar-color))]/40'}
                                    rounded={'rounded-full'}
                                    className={'mx-4'}
                                />
                            ))}
                        </div>
                        <div className="relative rounded-lg md:w-[45dvw] w-full">
                            {postCards.map((postcard, index) => (
                                <img
                                    key={postcard.alt}
                                    src={postcard.src}
                                    alt={postcard.alt}
                                    onAnimationEnd={() => handleAnimationEnd(index)}
                                    className={`
                                        absolute md:w-[50dvw] md:h-[30dvw] shadow-2xl
                                        origin-center ${postcard.isAnimating ? 'animate-fly-and-return' : `${postcard.rotation < 0 ? `${postcard.rotationClass}` : `${postcard.rotationClass}`}`}
                                        
                                    `}
                                    style={{
                                        zIndex: postcard.zIndex,
                                        '--postcard-rotation': `${postcard.rotation}deg`
                                    } as React.CSSProperties}
                                />
                            ))}
                            <div className=" relative space-y-4 p-8 z-10"/>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Schedule;
